export default __webpack_public_path__ + "static/media/ja.ad1da199.svg";